import * as React from "react"
import Footer from "./Footer"
import { Animate } from "react-simple-animate"
import ArrowTop from "../images/arrow-top.inline.svg"
import "./layout.css"

const Layout = ({ children, location }) => {
  const [show, setShow] = React.useState(false)
  const scrollHandler = () => setShow(window.scrollY > 300)

  React.useEffect(() => {
    window.addEventListener("scroll", scrollHandler)

    return () => window.removeEventListener("scroll", scrollHandler)
  })

  return (
    <React.Fragment>
      {children}
      <Footer />
      <Animate play={show} start={{ opacity: 0 }} end={{ opacity: 1 }}>
        <div className="scroll-top">
          <button
            className="scroll-circle w-inline-block"
            aria-label="Back to top"
            onClick={() =>
              window.scrollTo({
                left: 0,
                top: 0,
                behavior: "smooth",
              })
            }
          >
            <ArrowTop className="scroll-icon" />
          </button>
        </div>
      </Animate>
    </React.Fragment>
  )
}

export default Layout
